// extracted by mini-css-extract-plugin
export default {"container":"jY-z","list":"kY-z"};